import type { LandingPage } from 'tio-data/data/resources/company-setting.type';

/**
 * Whether a company's landing page should be shown: switched on and carrying
 * at least one piece of content. The login and welcome routes share this rule,
 * so one never sends a visitor to the other only to be sent back.
 *
 * @param landingPage the company's `landingPage` setting, possibly partial or absent
 */
export function isLandingPageShown(landingPage: Partial<LandingPage> | undefined): boolean {
  if (!landingPage?.isEnabled) return false;
  const { title, html, buttonText, externalLoginUrl } = landingPage;
  return [title, html, buttonText, externalLoginUrl].some((value) => !!value);
}
